//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PasswordRequirements from "~/themes/fiskarsMoominDefault/components/components/molecules/PasswordRequirements/PasswordRequirements.vue";
import SfCheckbox from "~/themes/fiskarsMoominDefault/components/components/molecules/SfCheckbox/SfCheckbox.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import {
  ref,
  computed,
  reactive,
  useContext,
  useRouter,
} from "@nuxtjs/composition-api";

import { validateEmail, validateName, markFieldAsTouched, touchedState, isFormValidated } from "~/helpers/validation-utils";
import { useVSFContext } from "@vue-storefront/core";
import { useUiNotification, useUserAccount } from "~/composables";
import {
  CMSNotificationType,
  extractCMSNotificationMessage,
} from "~/helpers/extractCMSNotificationMessage";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AttemptType } from "~/helpers/analytics/types";

export default {
  name: "RegisterForm",
  components: {
    PasswordRequirements,
    SfInput,
    SfButton,
    SfCheckbox,
    SfLoader,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    formLabel: {
      type: String,
    },
    firstNameLabel: {
      type: String,
    },
    firstNamePlaceholder: {
      type: String,
    },
    firstNameErrorMessage: {
      type: String,
    },
    lastNameLabel: {
      type: String,
    },
    lastNamePlaceholder: {
      type: String,
    },
    lastNameErrorMessage: {
      type: String,
    },
    emailLabel: {
      type: String,
    },
    emailPlaceholder: {
      type: String,
    },
    emailErrorMessage: {
      type: String,
    },
    emailFormatErrorMessage: {
      type: String,
    },
    passwordLabel: {
      type: String,
    },
    passwordPlaceholder: {
      type: String,
    },
    passwordErrorMessage: {
      type: String,
    },
    passwordSecurityErrorMessage: {
      type: String,
    },
    passwordRequirementsLabel: {
      type: String,
    },
    requirementEightCharacters: {
      type: String,
    },
    requirementSpecialCharacter: {
      type: String,
    },
    requirementUpperLowerCase: {
      type: String,
    },
    requirementContainsNumber: {
      type: String,
    },
    termsAndConditions: {
      type: String,
    },
    termsAndConditionsError: {
      type: String,
    },
    subscribeLabel: {
      type: String,
    },
    submitButton: {
      type: String,
    },
    captchaText: {
      type: String,
    },
    success: {
      type: Object,
    },
    error: {
      type: Object,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.getElementById("registerform");

      if (container) {
        container.addEventListener("click", (event) => {
          const dataType = event.target.getAttribute("data-type");

          if (!(dataType !== null && dataType === "internal")) {
            return;
          }
          this.$emit("toggleSignupModel");
          event.preventDefault();
          return false;
        });
      }
    });
  },

  setup(props, { emit }) {
    const router = useRouter();
    const { register: registerUser, loading, recaptchaFlag } = useUserAccount();
    const { localePath } = useVSFContext();
    const { i18n } = useContext();
    const { send: sendNotification } = useUiNotification();
    const firstName = ref("");
    const lastName = ref("");
    const email = ref("");
    const password = ref("");
    const passwordIsValid = ref(false);
    const acceptTC = ref(false);
    const subscribe = ref(false);
    const source = ref("03");

    const country = computed(() => i18n.localeProperties?.baseStoreCode);
    const language = computed(() => i18n.localeProperties?.language);

    const submit = async () => {
      if (!canSubmit.value) return false;

      try {
        // send token to server alongside your form data
        const data = {
          firstName: firstName.value,
          lastName: lastName.value,
          email: email.value,
          password: password.value,
          channelOptin: subscribe.value ? "yes" : "no",
          language: language.value,
          countryCode: country.value.toUpperCase(),
          source: source.value,
        };
        // Token has to be sent to server to verify it.
        // See https://github.com/nuxt-community/recaptcha-module/blob/master/example/base/v2/api/recaptcha.js
        // or https://developers.google.com/recaptcha/docs/verify
        const userName = `${data.firstName} ${data.lastName}`;

        const response = await registerUser(data);

        if (response?.status === 200) {
          analyticsEvents.signedUp(AttemptType.SUCCESS);
          sessionStorage.setItem("registrationName", userName);

          if (props.isModal) {
            emit("loggedIn", response);
          } else {
            router.push(localePath(i18n.t("PAGES.REGISTRATION_SUCCESS")));
          }
        } else {
          analyticsEvents.signedUp(AttemptType.FAILURE);
          sendNotification({
            type: CMSNotificationType.ERROR,
            message:
              extractCMSNotificationMessage(
                props.error,
                CMSNotificationType.ERROR,
                response?.errorCode
              ) ||
              response?.message ||
              "Registration error (hardcoded)",
          });
        }
      } catch (error) {}
    };

    const updatePasswordValidation = (validation) => {
      passwordIsValid.value = validation.isValid;
    };

    //password validations
    const passwordValidated = computed(() => passwordIsValid.value);

    //can submit form
    const canSubmit = computed(
      () =>
        !!(
          isFormValidated(formValues) &&
          !loading.value
        )
    );

    const formValues = reactive({
      firstName: {
        label: props.firstNameLabel,
        placeholder: props.firstNamePlaceholder,
        touched: touchedState(firstName.value),
        value: () => firstName.value,
        validation: computed(() => {
          if (!formValues.firstName.touched) {
            return { valid: true, error: "" };
          }
          const result = validateName(firstName.value, props.firstNameLabel, "firstName");
          return { valid: result.isValid, error: result.isValid ? "" : result.errorMessage };
        }),
      },
      lastName: {
        label: props.lastNameLabel,
        placeholder: props.lastNamePlaceholder,
        touched: touchedState(lastName.value),
        value: () => lastName.value,
        validation: computed(() => {
          if (!formValues.lastName.touched) {
            return { valid: true, error: "" };
          }
          const result = validateName(lastName.value, props.lastNameLabel, "lastName");
          return { valid: result.isValid, error: result.isValid ? "" : result.errorMessage };
        }),
      },
      email: {
        label: props.emailLabel,
        placeholder: props.emailPlaceholder,
        touched: touchedState(email.value),
        value: () => email.value,
        validation: computed(() => {
          if (!formValues.email.touched) return { valid: true, error: "" };
          const result = validateEmail(email.value, props.emailLabel);
          return {
            valid: result.isValid,
            error: result.isValid ? "" : result.errorMessage || props.emailFormatErrorMessage,
          };
        }),
      },
      password: {
        label: props.passwordLabel,
        placeholder: props.passwordPlaceholder,
        touched: touchedState(password.value),
        value: () => password.value,
        validation: computed(() => {
          if (!formValues.password.touched) return { valid: true, error: "" };
          return {
            valid: passwordValidated.value,
            error: password.value.length
              ? props.passwordSecurityErrorMessage
              : props.passwordErrorMessage,
          };
        })
      },
      termsAndConditions: {
        label: props.termsAndConditions,
        touched: touchedState(acceptTC.value),
        value: () => acceptTC.value,
        validation: computed(() => {
          if (!formValues.termsAndConditions.touched) return { valid: true, error: "" };
          return {
            valid: acceptTC.value,
            error: acceptTC.value ? "" : props.termsAndConditionsError,
          };
        }),
      },
    });

    return {
      firstName,
      lastName,
      email,
      loading,
      password,
      submit,
      canSubmit,
      acceptTC,
      subscribe,
      passwordValidated,
      formValues,
      markFieldAsTouched,
      updatePasswordValidation,
      recaptchaFlag
    };
  },
};
